/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Panel, WebRequest, Button } from '@cgn/framework-ui-components/v1';
import { MessaggiHeaderIcon } from '@cgn/framework-ui-components/icons';
import Messaggio from './Exports/Messaggio';
import Quesito from './Exports/Quesito';
import ModaleNuovoQuesito from './NuovoQuesito/ModaleNuovoQuesito';
import style from './Exports/DrawerStyle';
import ProfiloContext from './Shared/Profilo/ProfiloContext';
import { CodiceServizioHelpdesk, isServizioAttivo } from './domain/servizi/servizi';

class MenuInterno extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closed: true,
      messaggi: [],
      quesiti: [],
      loadingQuesiti: true,
      loadingMessaggi: true,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { ufficio } = this.props;
    const { closed } = this.state;
    if (ufficio !== nextProps.ufficio && !closed) {
      this.caricaQuesiti(nextProps.ufficio);
    }
  }

  toggle = () => {
    const { ufficio } = this.props;
    const { closed } = this.state;
    if (closed) {
      this.caricaMessaggi();
      this.caricaQuesiti(ufficio);
    }

    this.setState({ closed: !closed });
  };

  caricaMessaggi = async () => {
    const { utente } = this.props;
    const x = await WebRequest.get(
      '/Messaggi/DaLeggere',
      { identificativoUtente: utente.AccountId },
      false,
    );
    return this.setState({ messaggi: x, loadingMessaggi: false });
  };

  caricaQuesiti = async (ufficio) => {
    const { utente } = this.props;
    const x = await WebRequest.get(
      '/Pratica/DaLeggere',
      { codiceUfficio: ufficio, identificativoUtente: utente.AccountId },
      false,
    );
    return this.setState({ quesiti: x, loadingQuesiti: false });
  };

  onPreviewQuesito = (idPratica) => {
    const { history } = this.props;
    const { quesiti } = this.state;
    const pratica = quesiti.filter((x) => x.IdPratica === idPratica)[0];

    let url;
    if (pratica.Aperta) {
      url = `/messaggi/quesiti/aperti/quesito/${pratica.IdPratica}`;
    } else {
      url = `/messaggi/quesiti/chiusi/quesito/${pratica.IdPratica}`;
    }

    this.setState({ closed: true }, () => history.push(url));
  };

  onPreviewMessaggio = (idInvio) => {
    const { messaggi } = this.state;
    const { history } = this.props;
    const messaggio = messaggi.filter((x) => x.IdInvio === idInvio)[0];
    this.setState({ closed: true }, () => history.push(
      `/messaggi/comunicazioni/${messaggio.IdCanaleTematico}/${messaggio.IdInvio}`,
    ));
  };

  render() {
    const {
      totale, utente, ufficio, container,
    } = this.props;
    const {
      closed,
      loadingQuesiti,
      modaleNuovoQuesito,
      quesiti,
      loadingMessaggi,
      messaggi,
    } = this.state;

    const servizioHelpdeskAttivo = isServizioAttivo(utente, ufficio, CodiceServizioHelpdesk);

    return (
      <span style={{ position: 'relative', display: 'block', float: 'right' }}>
        {totale > 0 && (
          <span
            className="badge badge--alarm"
            style={{ position: 'absolute', top: '5px', right: '5px' }}
          >
            {totale}
          </span>
        )}
        <MessaggiHeaderIcon
          onClick={() => this.toggle()}
          style={{ cursor: 'pointer' }}
        />
        {ReactDOM.createPortal(
          <div>
            <div
              style={closed ? style.background : style.backgroundOpen}
              onClick={() => this.toggle()}
            />

            <div style={closed ? style.menu : style.menuOpen}>
              {!closed
                && !loadingQuesiti
                && ufficio != null
                && servizioHelpdeskAttivo
                && (
                  <Button
                    primary
                    onClick={() => this.setState({ modaleNuovoQuesito: true, closed: true })}
                  >
                    Crea quesito
                  </Button>
                )}
              {utente && (
                <ProfiloContext.Provider value={utente}>
                  <ModaleNuovoQuesito
                    show={modaleNuovoQuesito}
                    ufficioSelezionato={ufficio}
                    onClose={() => this.setState({ modaleNuovoQuesito: false })}
                    onOpenFeedbackConfermaInvio={() => { }}
                    onCloseFeedbackConfermaInvio={() => this.setState({ modaleNuovoQuesito: false })}
                    origine="support-drawer"
                  />
                </ProfiloContext.Provider>
              )}

              {!closed && !loadingQuesiti && (
                <div>
                  <h4 style={{ marginTop: '10px' }}>Quesiti</h4>
                  {quesiti.length === 0 && (
                    <Panel info>Nessun quesito da leggere.</Panel>
                  )}
                  {quesiti.length > 0
                    && quesiti.map((x) => (
                      <Quesito
                        key={x.IdPratica}
                        data={x}
                        onPreview={this.onPreviewQuesito}
                      />
                    ))}
                </div>
              )}

              {!closed && !loadingMessaggi && (
                <div>
                  <h4>Messaggi</h4>
                  {messaggi.length === 0 && (
                    <Panel info>Nessun messaggio da leggere.</Panel>
                  )}
                  {messaggi.length > 0
                    && messaggi.map((x) => (
                      <Messaggio
                        key={x.IdInvio}
                        data={x}
                        onPreview={this.onPreviewMessaggio}
                      />
                    ))}
                </div>
              )}
            </div>
          </div>,
          container,
        )}
      </span>
    );
  }
}

MenuInterno.propTypes = {
  container: PropTypes.instanceOf(HTMLDivElement),
  totale: PropTypes.number,
  ufficio: PropTypes.string,
  utente: PropTypes.shape({
    AccountId: PropTypes.string,
    Nome: PropTypes.string,
    Cognome: PropTypes.string,
    Uffici: PropTypes.arrayOf(
      PropTypes.shape({
        CodiceUfficio: PropTypes.string,
        CodiceServizio: PropTypes.string,
      }),
    ),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

MenuInterno.defaultProps = {
  container: undefined,
  totale: undefined,
  ufficio: undefined,
  utente: undefined,
};

export default MenuInterno;
